"use client"

import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useMusicContext } from "@/context/musicContext"

export default function useKeyboardShortcuts() {
  const navigate = useNavigate()

  const {
    togglePlayPause,
  } = useMusicContext()

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement
      const tag = target.tagName

      // No ejecutar atajos mientras se escribe
      if (
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        tag === "SELECT" ||
        target.isContentEditable
      ) {
        return
      }

      // SPACE → Play / Pause / Stop radio
      if (e.code === "Space") {
        e.preventDefault()
        togglePlayPause()
        return
      }

      // CMD + K → Buscar
      if (
        e.metaKey &&
        e.key.toLowerCase() === "k"
      ) {
        e.preventDefault()
        navigate("/buscar")
        return
      }

      // Atajos numéricos
      switch (e.key) {
        case "1":
          navigate("/")
          break

        case "2":
          navigate("/library")
          break

        case "3":
          navigate("/radio")
          break

        case "4":
          navigate("/news")
          break

        case "5":
          navigate("/ajustes")
          break
      }
    }

    window.addEventListener("keydown", handler)

    return () => {
      window.removeEventListener("keydown", handler)
    }
  }, [
    navigate,
    togglePlayPause,
  ])
}